import { AfterViewInit,Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { sectorizationGraphData } from 'src/app/models/sectorizationGraphData';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { Options } from '@angular-slider/ngx-slider';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-sectorization-display',
  templateUrl: './sectorization-display.component.html',
  styleUrls: ['../../../app.component.scss', './sectorization-display.component.scss'],
  standalone: false
})
export class SectorizationDisplayComponent implements OnInit, AfterViewInit {

  @Input() sectorizationData : sectorizationGraphData;
  imageSanitized;
  imageUrl: string;
  defaultDoc : number;

  sliderIndex: number = 0;
  sliderSteps: number[] = []; // your discrete steps
  sliderValue: number = 0;
  sliderOptions: Options = {
    floor: 0,
    ceil: 100,
    step: 1,
    showTicks: true,
    tickValueStep: 1,
    getPointerColor: () => '#3f51b5'
  };

  selectedRangeMin: number;
  selectedRangeMax: number;


  constructor(
    private http: HttpClient,
    private sanitizerService: DomSanitizer,
    private bsModalRef : BsModalRef,
    private endpointService: EndpointsService,
    private cdr: ChangeDetectorRef) {
     }

  ngAfterViewInit(): void {
    setTimeout( () => {
      this.importData();
    })
  }

  ngOnInit(): void {
  }

  cancel() {
    this.bsModalRef.hide();
  }

  importData() {
    if(this.sectorizationData != undefined){
      this.imageSanitized = this.sanitizerImage(this.sectorizationData.imageBase64);
      this.initSlider();
      this.defaultDoc = this.sectorizationData.defaultDOC;
    }
  }

  sanitizerImage(imageBase64: string) {
    this.imageUrl = 'data:image/bmp;base64,' + imageBase64;
    return this.sanitizerService.bypassSecurityTrustResourceUrl(this.imageUrl);
  }

   initSlider() {
    if (Array.isArray(this.sectorizationData.altitudeRanges) && this.sectorizationData.altitudeRanges.length > 1) {
      this.sliderSteps = this.sectorizationData.altitudeRanges;
      this.sliderValue = 0;
      this.sliderIndex = 0;
      this.updateSliderOptions();
      this.updateRangeValues();
    }
  }

  updateSliderOptions(): void {
    this.sliderOptions = {
      floor: 0,
      ceil: this.sliderSteps.length - 2,
      step: 1,
      showTicks: true,
      tickValueStep: 1,
      getPointerColor: () => '#3f51b5',
      translate: (value: number): string => {
        return ''; // removes the top label
      }
    };
    this.cdr.detectChanges();
  }


  onSliderChange(value: number) {
    this.sliderValue = value["value"];
    this.sliderIndex = value["value"];

    // Change values of active range
    this.updateRangeValues();

    // Get new image to display
    this.sectorizationData.indexRange = this.sliderIndex;
    this.updateSectorizationDisplay(this.sectorizationData)
      .subscribe((sectorization: sectorizationGraphData) => {
        this.imageSanitized = this.sanitizerImage(sectorization.imageBase64);
      }
    );

  }

  displayStepLabel(index: number): string {
    return this.sliderSteps && this.sliderSteps[index] !== undefined
      ? this.sliderSteps[index].toString()
      : '';
  }


  updateSectorizationDisplay(sectorization: sectorizationGraphData){
    return this.http.post(
      this.endpointService.sectorizationDisplayUrl,
      sectorization,
      this.endpointService.httpOptions
    );
  }

  updateRangeValues() {
    if (
      Array.isArray(this.sliderSteps) &&
      this.sliderIndex >= 0 &&
      this.sliderIndex < this.sliderSteps.length - 1
    ) {
      this.selectedRangeMin = this.sliderSteps[this.sliderIndex];
      this.selectedRangeMax = this.sliderSteps[this.sliderIndex + 1];
    } else {
      this.selectedRangeMin = undefined;
      this.selectedRangeMax = undefined;
    }
  }

}